import { render, staticRenderFns } from "./ClientCRMDrawer.vue?vue&type=template&id=47c46a90&scoped=true"
import script from "./ClientCRMDrawer.vue?vue&type=script&lang=js"
export * from "./ClientCRMDrawer.vue?vue&type=script&lang=js"
import style0 from "./ClientCRMDrawer.vue?vue&type=style&index=0&id=47c46a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c46a90",
  null
  
)

export default component.exports